/* =====================================================================
   Maison Stiletto V5 : window.MP (fondations JS communes)
   Charge en defer par sections/mp-global.liquid, AVANT mp-header.js, mp-cart.js
   et les scripts de surface. Aucune dependance. Guide : refonte/FONDATIONS.md
   API : MP.config, MP.money, MP.layer, MP.rows, MP.eta, MP.add, MP.errorText,
         MP.announce, MP.section, MP.portal, MP.ready, MP.debounce, MP.mq,
         MP.locale, MP.localeTag, MP.i18n, MP.t, MP.fmt, MP.date (langue et chaines, voir SPEC-I18N)
   ===================================================================== */
(function () {
  'use strict';

  if (window.MP && window.MP.__base) return; // deja charge (double inclusion)

  var doc = document;
  var html = doc.documentElement;

  /* ---------- Outils ---------- */
  function ready(fn) {
    if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', fn, { once: true });
    else fn();
  }
  function toArray(list) { return Array.prototype.slice.call(list || []); }
  function emit(target, name, detail) {
    var ev;
    try { ev = new CustomEvent(name, { bubbles: true, detail: detail || {} }); }
    catch (e) { ev = doc.createEvent('CustomEvent'); ev.initCustomEvent(name, true, false, detail || {}); }
    (target || doc).dispatchEvent(ev);
  }
  // le panneau navigateur masque ne declenche pas requestAnimationFrame : repli sur setTimeout
  function raf(fn) {
    if (doc.hidden || !window.requestAnimationFrame) return setTimeout(fn, 16);
    return window.requestAnimationFrame(fn);
  }
  function debounce(fn, ms) {
    var t;
    return function () {
      var ctx = this, args = arguments;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, ms || 150);
    };
  }
  function mq(q) {
    return window.matchMedia ? window.matchMedia(q) : { matches: false, addEventListener: function () {} };
  }
  var MQ = {
    desktop: mq('(min-width: 990px)'),
    hover: mq('(hover: hover) and (pointer: fine)'),
    reduce: mq('(prefers-reduced-motion: reduce)')
  };
  function behavior() { return MQ.reduce.matches ? 'auto' : 'smooth'; }
  function pad2(n) { return (n < 10 ? '0' : '') + n; }

  /* ---------- Configuration (#mp-config rendu par mp-global) ---------- */
  var DEFAULTS = {
    freeShipping: 0, // centimes ; 0 = livraison standard toujours offerte
    etaMin: 8,
    etaMax: 10,
    cutoffEnabled: false,
    cutoffHour: 14,
    offerBadge: '',
    offerText: '',
    timezone: '', // vide = fuseau du visiteur
    locale: 'en', // langue de la boutique (request.locale.iso_code) : en, fr...
    root: '/', // routes.root_url : "/" (langue principale) ou "/fr"
    roots: [], // racines de toutes les langues de la boutique (liens deja prefixes d'une autre langue)
    money: { format: 'en', symbol: '$' },
    routes: {
      root: '/',
      cart: '/cart',
      cartAdd: '/cart/add.js',
      cartUpdate: '/cart/update.js',
      cartChange: '/cart/change.js',
      search: '/search',
      predictive: '/search/suggest'
    }
  };
  function readConfig() {
    var c = {};
    var el = doc.getElementById('mp-config');
    if (el) {
      try { c = JSON.parse(el.textContent || '{}') || {}; } catch (e) { c = {}; }
    }
    var out = {};
    var k;
    for (k in DEFAULTS) out[k] = DEFAULTS[k];
    for (k in c) out[k] = c[k];
    out.money = {};
    for (k in DEFAULTS.money) out.money[k] = DEFAULTS.money[k];
    if (c.money) for (k in c.money) out.money[k] = c.money[k];
    out.routes = {};
    for (k in DEFAULTS.routes) out.routes[k] = DEFAULTS.routes[k];
    if (c.routes) for (k in c.routes) out.routes[k] = c.routes[k];
    out.freeShipping = Number(out.freeShipping) || 0;
    out.etaMin = Math.max(0, parseInt(out.etaMin, 10) || 0);
    out.etaMax = Math.max(out.etaMin, parseInt(out.etaMax, 10) || 0);
    out.cutoffHour = Math.min(23, Math.max(0, parseInt(out.cutoffHour, 10) || 0));
    out.cutoffEnabled = out.cutoffEnabled === true;
    return out;
  }
  var cfg = readConfig();

  /* ---------- Langue : chaines (blocs data-mp-i18n) et formats ---------- */
  // Chaque section rend ses chaines dans <script type="application/json" data-mp-i18n="<surface>">{...}</script>
  // (objet plat, variables sous la forme [nom]). MP.t(surface, cle, repli, vars) lit la chaine et, si elle manque,
  // renvoie le repli anglais. Les blocs sont lus a la demande (jamais en cache s'ils sont vides).
  var i18nCache = {};
  function i18n(surface) {
    if (i18nCache[surface]) return i18nCache[surface];
    var out = {};
    var n = 0;
    toArray(doc.querySelectorAll('script[data-mp-i18n="' + surface + '"]')).forEach(function (el) {
      var o = null;
      try { o = JSON.parse(el.textContent || '{}'); } catch (e) { o = null; }
      if (!o) return;
      for (var k in o) { out[k] = o[k]; n++; }
    });
    if (n) i18nCache[surface] = out;
    return out;
  }
  // [nom], {nom} et {{ nom }} sont remplaces par vars.nom
  function fmtStr(str, vars) {
    var s = String(str == null ? '' : str);
    if (!vars) return s;
    return s.replace(/\[(\w+)\]|\{\{\s*(\w+)\s*\}\}|\{(\w+)\}/g, function (m, a, b, c) {
      var key = a || b || c;
      return Object.prototype.hasOwnProperty.call(vars, key) ? String(vars[key]) : m;
    });
  }
  function tr(surface, key, fallback, vars) {
    var o = i18n(surface);
    var v = o ? o[key] : null;
    if (v == null || v === '' || /^translation missing/i.test(String(v))) v = fallback;
    return fmtStr(v, vars);
  }
  function g(key, vars) { return tr('general', key, GENERAL[key], vars); }
  // repli anglais des chaines des fondations (cles de mp.general.* rendues par mp-global)
  var GENERAL = {
    adding: 'Adding…',
    added: 'Added',
    added_announce: 'Added to bag.',
    select_size: 'Select a size.',
    error_generic: 'Something went wrong. Please try again in a moment.',
    error_sold_out: 'This size is sold out.',
    error_max: 'Maximum quantity reached for this item.',
    eta_between: 'between [date1] and [date2]',
    eta_on: 'on [date1]',
    eta_from: 'from [date1] to [date2]',
    cutoff: 'Order within [time] to ship today.',
    time_h: '[h] h',
    time_hm: '[h] h [m] min',
    time_m: '[m] min',
    sale_price: 'Sale price',
    regular_price: 'Regular price',
    price_from: 'From',
    sold_out: 'Sold out',
    shop_all: 'Shop all'
  };
  // langue courante : "en" ou "fr" (premier segment de l'iso), etiquette BCP 47 pour Intl
  var lang = String(cfg.locale || doc.documentElement.lang || 'en').toLowerCase().split('-')[0];
  var localeTag = lang === 'fr' ? 'fr-FR' : (lang === 'en' ? 'en-US' : String(cfg.locale || 'en-US'));

  /* ---------- Prefixe de langue (/fr) : liens internes et URL d'API ---------- */
  // Sur la boutique en francais, un lien ecrit en dur ("/pages/size-guide") ramenerait le visiteur en anglais.
  // Les liens de menu et les routes Liquid sont deja localises par Shopify ; tout le reste est corrige ici :
  // href des liens et action des formulaires GET juste avant la navigation, URL d'API (cart, recherche, sections).
  // Exclusions : data-mp-no-locale (sur le lien, le formulaire ou un parent), ancres, liens externes, mailto/tel,
  // /cdn/, /apps/, /a/, /account, /checkout, /services/, /localization, /tools/, /admin.
  function normRoot(r) {
    r = String(r == null ? '' : r).trim().replace(/\/+$/, '');
    if (!r) return '';
    return r.charAt(0) === '/' ? r : '/' + r;
  }
  var root = normRoot(cfg.root || (cfg.routes && cfg.routes.root) || (window.Shopify && window.Shopify.routes && window.Shopify.routes.root));
  var otherRoots = (Array.isArray(cfg.roots) ? cfg.roots : []).map(normRoot).filter(function (r) { return r && r !== root; });
  var NO_LOCALE = /^\/(?:cdn|apps|a|account|checkouts?|services|localization|tools|wpm|admin|\.well-known)(?:[\/?#]|$)/i;
  function hasRoot(p, r) {
    return p === r || p.indexOf(r + '/') === 0 || p.indexOf(r + '?') === 0 || p.indexOf(r + '#') === 0;
  }
  // p : chemin commencant par "/" (avec ?requete et #ancre eventuels) ; renvoie le chemin prefixe si besoin
  function localizePath(p) {
    if (!root || typeof p !== 'string' || p.charAt(0) !== '/' || p.charAt(1) === '/') return p;
    if (hasRoot(p, root) || NO_LOCALE.test(p)) return p;
    for (var i = 0; i < otherRoots.length; i++) if (hasRoot(p, otherRoots[i])) return p;
    return root + p;
  }
  // chemin ("/..."), ou URL absolue de la meme origine ; le reste est renvoye tel quel
  function localizeAny(u) {
    if (!root || typeof u !== 'string') return u;
    if (u.charAt(0) === '/' && u.charAt(1) !== '/') return localizePath(u);
    if (/^(?:https?:)?\/\//i.test(u)) {
      try {
        var x = new URL(u, window.location.href);
        if (x.origin !== window.location.origin) return u;
        var fixed = localizePath(x.pathname) + x.search + x.hash;
        return fixed === x.pathname + x.search + x.hash ? u : x.origin + fixed;
      } catch (e) { return u; }
    }
    return u;
  }
  function localizeRoutes() {
    ['cart', 'cartAdd', 'cartUpdate', 'cartChange', 'search', 'predictive'].forEach(function (k) {
      if (cfg.routes && typeof cfg.routes[k] === 'string') cfg.routes[k] = localizePath(cfg.routes[k]);
    });
  }
  localizeRoutes();

  /* ---------- Prix : meme rendu que le snippet mp-money ---------- */
  // 8800 -> "$88" ; 8850 -> "$88.50" ; 125000 -> "$1,250" (equivalent de money_without_trailing_zeros)
  // Avec le format de la boutique (money.pattern, ex. "€{{amount_with_comma_separator}}") : meme rendu que le
  // filtre Liquid, pour que les prix calcules en JS suivent la devise et la langue (8850 -> "€88,50")
  function money(cents, symbol) {
    var n = Math.round(Number(cents) || 0);
    var neg = n < 0;
    n = Math.abs(n);
    var whole = Math.floor(n / 100);
    var rest = n % 100;
    var pattern = !symbol && cfg.money.pattern;
    var m = pattern && /\{\{\s*(\w+)\s*\}\}/.exec(pattern);
    if (m) {
      var th = ',', dec = '.';
      if (m[1].indexOf('comma_separator') > -1) { th = '.'; dec = ','; }
      else if (m[1].indexOf('space_separator') > -1) { th = ' '; dec = ','; }
      else if (m[1].indexOf('apostrophe_separator') > -1) { th = "'"; }
      if (m[1].indexOf('no_decimals') > -1) { whole = Math.round(n / 100); rest = 0; }
      var a = String(whole).replace(/\B(?=(\d{3})+(?!\d))/g, th);
      if (rest) a += dec + pad2(rest);
      return (neg ? '−' : '') + pattern.replace(m[0], a);
    }
    var s = String(whole).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    if (rest) s += '.' + pad2(rest);
    return (neg ? '\u2212' : '') + (symbol || cfg.money.symbol || '$') + s;
  }

  /* ---------- Annonces lecteur d'ecran ---------- */
  var live = null;
  function announce(text) {
    if (!live) {
      live = doc.createElement('div');
      live.id = 'mp-live';
      live.className = 'mp-vh';
      live.setAttribute('aria-live', 'polite');
      live.setAttribute('aria-atomic', 'true');
      doc.body.appendChild(live);
    }
    live.textContent = '';
    setTimeout(function () { live.textContent = text || ''; }, 60);
  }

  /* ---------- Deplacer un element dans body (calques poses dans un groupe de sections) ---------- */
  function portal(el) {
    if (el && el.parentNode !== doc.body) doc.body.appendChild(el);
    return el;
  }

  /* ---------- Calques : MP.layer ---------- */
  // Un seul calque ouvert (tiroir panier, menu mobile, filtres, recherche, guide des tailles).
  // Voile partage, html.mp-lock, focus piege, Echap, retour du focus a l'element d'ouverture.
  var layer = (function () {
    var current = null;
    var opener = null;
    var options = {};
    var scrim = null;
    var FOCUSABLE = 'a[href], area[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), summary, iframe, [contenteditable="true"], [tabindex]:not([tabindex="-1"])';

    function getScrim() {
      if (!scrim) {
        scrim = doc.createElement('div');
        scrim.className = 'mp-scrim';
        scrim.setAttribute('data-mp-scrim', '');
        scrim.setAttribute('aria-hidden', 'true');
        doc.body.appendChild(scrim);
        scrim.addEventListener('click', function () { close(); });
      }
      return scrim;
    }
    function visible(el) {
      if (!el.getClientRects().length) return false;
      var cs = window.getComputedStyle(el);
      return cs.visibility !== 'hidden' && cs.display !== 'none';
    }
    function focusables(root) {
      return toArray(root.querySelectorAll(FOCUSABLE)).filter(visible);
    }
    function setExpanded(panel, value) {
      if (!panel.id) return;
      toArray(doc.querySelectorAll('[aria-controls="' + panel.id + '"]')).forEach(function (b) {
        if (b.hasAttribute('aria-expanded')) b.setAttribute('aria-expanded', value);
      });
    }
    function lock(on) {
      if (on) {
        var w = window.innerWidth - html.clientWidth;
        html.style.setProperty('--mp-sbw', (w > 0 ? w : 0) + 'px');
        html.classList.add('mp-lock');
      } else {
        html.classList.remove('mp-lock');
        html.style.removeProperty('--mp-sbw');
      }
    }
    function open(panel, openerEl, opts) {
      if (typeof panel === 'string') panel = doc.getElementById(panel);
      if (!panel) return;
      if (current === panel) return;
      if (current) close({ silent: true, keepScrim: true });
      options = opts || {};
      opener = openerEl || doc.activeElement;
      current = panel;
      if (!panel.hasAttribute('tabindex')) panel.setAttribute('tabindex', '-1');
      if (!panel.getAttribute('role')) panel.setAttribute('role', 'dialog');
      if (panel.getAttribute('role') === 'dialog') panel.setAttribute('aria-modal', 'true');
      panel.removeAttribute('inert');
      panel.setAttribute('aria-hidden', 'false');
      panel.classList.add('is-open');
      if (options.scrim !== false) getScrim().classList.add('is-on');
      else if (scrim) scrim.classList.remove('is-on');
      // lock:false (ex. mega menu) : la page reste defilable, meme si le calque precedent la bloquait
      lock(options.lock !== false);
      setExpanded(panel, 'true');
      setTimeout(function () {
        if (current !== panel) return;
        var target = panel.querySelector('[data-mp-autofocus]') || panel;
        try { target.focus({ preventScroll: true }); } catch (e) { target.focus(); }
      }, 60);
      emit(panel, 'mp:layer:open', { panel: panel, opener: opener });
    }
    function close(o) {
      o = o || {};
      var panel = current;
      if (!panel) return;
      var back = opener;
      var cb = options.onClose;
      current = null;
      opener = null;
      options = {};
      panel.classList.remove('is-open');
      panel.setAttribute('aria-hidden', 'true');
      setExpanded(panel, 'false');
      if (!o.keepScrim && scrim) scrim.classList.remove('is-on');
      if (!o.keepScrim) lock(false);
      if (!o.silent && back && back.focus && doc.contains(back)) {
        try { back.focus({ preventScroll: true }); } catch (e) { back.focus(); }
      }
      if (typeof cb === 'function') cb(panel);
      emit(panel, 'mp:layer:close', { panel: panel });
    }
    function toggle(panel, openerEl, opts) {
      if (typeof panel === 'string') panel = doc.getElementById(panel);
      if (panel && current === panel) close();
      else open(panel, openerEl, opts);
    }

    doc.addEventListener('keydown', function (e) {
      if (!current || e.defaultPrevented) return;
      if (e.key === 'Escape' || e.key === 'Esc') {
        close();
        return;
      }
      if (e.key !== 'Tab') return;
      var f = focusables(current);
      if (!f.length) { e.preventDefault(); current.focus(); return; }
      var first = f[0];
      var last = f[f.length - 1];
      var active = doc.activeElement;
      if (!current.contains(active)) { e.preventDefault(); first.focus(); return; }
      if (e.shiftKey && (active === first || active === current)) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && active === last) { e.preventDefault(); first.focus(); }
    });
    doc.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var opn = t.closest('[data-mp-layer-open]');
      if (opn) {
        var target = doc.getElementById(opn.getAttribute('data-mp-layer-open'));
        if (target) { e.preventDefault(); toggle(target, opn); }
        return;
      }
      var cls = t.closest('[data-mp-layer-close]');
      if (cls && current && current.contains(cls)) { e.preventDefault(); close(); }
    });

    return {
      open: open,
      close: close,
      toggle: toggle,
      current: function () { return current; },
      isOpen: function (panel) { return !!current && (!panel || current === panel); },
      lock: lock
    };
  })();

  /* ---------- Rangees : MP.rows(scope) ---------- */
  // [data-mp-row] > [data-mp-row-track] (une piste par onglet), [data-mp-row-prev|next],
  // [data-mp-row-progress] > span, onglets [role=tab][aria-controls=<id de piste>]
  function initRow(row) {
    if (row.__mpRow) { row.__mpRow.update(); return row.__mpRow; }
    var tracks = toArray(row.querySelectorAll('[data-mp-row-track]'));
    if (!tracks.length) return null;
    var tabs = toArray(row.querySelectorAll('[role="tab"]'));
    var prev = row.querySelector('[data-mp-row-prev]');
    var next = row.querySelector('[data-mp-row-next]');
    var bar = row.querySelector('[data-mp-row-progress]');
    var link = row.querySelector('[data-mp-row-link]');
    var pending = false;

    function active() {
      for (var i = 0; i < tracks.length; i++) if (!tracks[i].hidden) return tracks[i];
      return tracks[0];
    }
    function gapOf(t) {
      var cs = window.getComputedStyle(t);
      return parseFloat(cs.columnGap || cs.gap) || 0;
    }
    function update() {
      pending = false;
      var t = active();
      var max = t.scrollWidth - t.clientWidth;
      var x = Math.abs(t.scrollLeft);
      var isStatic = max <= 2;
      row.classList.toggle('is-static', isStatic);
      if (prev) prev.disabled = isStatic || x <= 2;
      if (next) next.disabled = isStatic || x >= max - 2;
      if (bar) {
        var thumb = t.scrollWidth ? Math.min(1, t.clientWidth / t.scrollWidth) : 1;
        var pos = max > 0 ? Math.min(1, x / max) : 0;
        var bw = bar.clientWidth;
        bar.style.setProperty('--mp-row-thumb', (thumb * 100).toFixed(3) + '%');
        bar.style.setProperty('--mp-row-x', (pos * (bw - bw * thumb)).toFixed(1) + 'px');
      }
    }
    function schedule() {
      if (pending) return;
      pending = true;
      raf(update);
    }
    function step(dir) {
      var t = active();
      var item = t.firstElementChild;
      var gap = gapOf(t);
      var w = item ? item.getBoundingClientRect().width + gap : t.clientWidth;
      var per = Math.max(1, Math.floor((t.clientWidth + gap) / Math.max(1, w)));
      t.scrollBy({ left: dir * per * w, behavior: behavior() });
    }
    function select(index, focus) {
      if (!tabs.length) return;
      index = (index + tabs.length) % tabs.length;
      tabs.forEach(function (tab, i) {
        var on = i === index;
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.setAttribute('tabindex', on ? '0' : '-1');
        tab.classList.toggle('is-active', on);
        var panel = doc.getElementById(tab.getAttribute('aria-controls'));
        if (panel) {
          panel.hidden = !on;
          if (on) panel.scrollLeft = 0;
        }
      });
      var cur = tabs[index];
      if (focus) cur.focus();
      if (link && cur.getAttribute('data-url')) link.setAttribute('href', cur.getAttribute('data-url'));
      schedule();
      emit(row, 'mp:row:tab', { index: index, tab: cur, panel: doc.getElementById(cur.getAttribute('aria-controls')) });
    }

    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
    tracks.forEach(function (t) { t.addEventListener('scroll', schedule, { passive: true }); });
    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { select(i, false); });
      tab.addEventListener('keydown', function (e) {
        var k = e.key;
        var to = null;
        if (k === 'ArrowRight' || k === 'Right') to = i + 1;
        else if (k === 'ArrowLeft' || k === 'Left') to = i - 1;
        else if (k === 'Home') to = 0;
        else if (k === 'End') to = tabs.length - 1;
        if (to === null) return;
        e.preventDefault();
        select(to, true);
      });
    });
    if (tabs.length) {
      var start = 0;
      tabs.forEach(function (tab, i) { if (tab.getAttribute('aria-selected') === 'true') start = i; });
      select(start, false);
    }
    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(schedule);
      tracks.forEach(function (t) { ro.observe(t); });
      if (bar) ro.observe(bar);
    } else {
      window.addEventListener('resize', debounce(schedule, 120));
    }
    window.addEventListener('load', schedule, { once: true });
    update();

    row.__mpRow = { update: update, select: select, step: step, active: active };
    return row.__mpRow;
  }
  function rows(scope) {
    var root = scope || doc;
    var list = toArray(root.querySelectorAll('[data-mp-row]'));
    if (root.matches && root.matches('[data-mp-row]')) list.unshift(root);
    return list.map(initRow).filter(Boolean);
  }

  /* ---------- Dates de livraison : MP.eta(scope) ---------- */
  // Jours ouvres lundi-vendredi, fuseau du visiteur (ou config.timezone si renseigne), aucun jour ferie.
  function isBusinessDay(d) {
    var w = d.getUTCDay();
    return w !== 0 && w !== 6;
  }
  function nowParts() {
    var now = new Date();
    if (cfg.timezone) {
      try {
        var f = new Intl.DateTimeFormat('en-GB', {
          timeZone: cfg.timezone,
          year: 'numeric', month: '2-digit', day: '2-digit',
          hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
        });
        var o = {};
        f.formatToParts(now).forEach(function (p) { o[p.type] = p.value; });
        return { y: +o.year, m: +o.month, d: +o.day, h: (+o.hour) % 24, mi: +o.minute };
      } catch (e) { /* repli : fuseau du visiteur */ }
    }
    return { y: now.getFullYear(), m: now.getMonth() + 1, d: now.getDate(), h: now.getHours(), mi: now.getMinutes() };
  }
  // jour de depart du decompte : aujourd'hui, ou le prochain jour ouvre si l'heure limite
  // (reelle, activee dans l'editeur) est passee ou si l'on n'est pas un jour ouvre
  function startDay(p) {
    var d = new Date(Date.UTC(p.y, p.m - 1, p.d, 12));
    if (cfg.cutoffEnabled && (!isBusinessDay(d) || p.h >= cfg.cutoffHour)) {
      do { d.setUTCDate(d.getUTCDate() + 1); } while (!isBusinessDay(d));
    }
    return d;
  }
  function addBusinessDays(from, n) {
    var d = new Date(from.getTime());
    var added = 0;
    while (added < n) {
      d.setUTCDate(d.getUTCDate() + 1);
      if (isBusinessDay(d)) added++;
    }
    return d;
  }
  var MONTHS = {
    en: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    fr: ['janv.', 'févr.', 'mars', 'avr.', 'mai', 'juin', 'juil.', 'août', 'sept.', 'oct.', 'nov.', 'déc.']
  };
  var DAYS = {
    en: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    fr: ['dim.', 'lun.', 'mar.', 'mer.', 'jeu.', 'ven.', 'sam.']
  };
  var fmtFull;
  // date courte selon la langue : "Mon, Oct 20" (en-US) ; "lun. 20 oct." (fr-FR)
  function fmt(d) {
    try {
      if (!fmtFull) fmtFull = new Intl.DateTimeFormat(localeTag, { weekday: 'short', month: 'short', day: 'numeric', timeZone: 'UTC' });
      return fmtFull.format(d);
    } catch (e) {
      var l = lang === 'fr' ? 'fr' : 'en';
      var day = DAYS[l][d.getUTCDay()];
      var mon = MONTHS[l][d.getUTCMonth()];
      return l === 'fr' ? day + ' ' + d.getUTCDate() + ' ' + mon : day + ', ' + mon + ' ' + d.getUTCDate();
    }
  }
  function etaDates(min, max) {
    var base = startDay(nowParts());
    return { a: addBusinessDays(base, min), b: addBusinessDays(base, max) };
  }
  // phrases (chaines mp.general.eta_*) : "between Wed, Oct 21 and Fri, Oct 23" / "entre le mer. 21 oct. et le ven. 23 oct."
  function etaPhrase(a, b, mode) {
    var same = a.getTime() === b.getTime();
    if (mode === 'min') return fmt(a);
    if (mode === 'max') return fmt(b);
    if (same) return g('eta_on', { date1: fmt(a) });
    if (mode === 'du') return g('eta_from', { date1: fmt(a), date2: fmt(b) });
    return g('eta_between', { date1: fmt(a), date2: fmt(b) });
  }
  // "ven. 23 oct." suivi du point de la phrase : un seul point ("23 oct.." sinon)
  function endDot(el, text) {
    var n = el.nextSibling;
    if (text.slice(-1) === '.' && n && n.nodeType === 3 && n.nodeValue.charAt(0) === '.') return text.slice(0, -1);
    return text;
  }
  function renderEta(el) {
    var min = el.hasAttribute('data-min') ? parseInt(el.getAttribute('data-min'), 10) : cfg.etaMin;
    var max = el.hasAttribute('data-max') ? parseInt(el.getAttribute('data-max'), 10) : cfg.etaMax;
    if (isNaN(min)) min = cfg.etaMin;
    if (isNaN(max) || max < min) max = Math.max(min, cfg.etaMax);
    var r = etaDates(min, max);
    var ea = el.querySelector('[data-eta-a]');
    var eb = el.querySelector('[data-eta-b]');
    if (ea || eb) {
      if (ea) ea.textContent = fmt(r.a);
      if (eb) eb.textContent = endDot(eb, fmt(r.b));
    } else {
      var mode = el.getAttribute('data-mp-eta') || 'between';
      if (mode === 'entre') mode = 'between'; // ancien nom V5 du mode par defaut
      el.textContent = endDot(el, etaPhrase(r.a, r.b, mode));
    }
    el.setAttribute('data-mp-eta-ready', '');
  }
  function renderCutoff(el) {
    var p = nowParts();
    var today = new Date(Date.UTC(p.y, p.m - 1, p.d, 12));
    var left = cfg.cutoffHour * 60 - (p.h * 60 + p.mi);
    if (!cfg.cutoffEnabled || !isBusinessDay(today) || left <= 0) {
      el.hidden = true;
      return;
    }
    var h = Math.floor(left / 60);
    var m = left % 60;
    var txt = h ? (m ? g('time_hm', { h: h, m: pad2(m) }) : g('time_h', { h: h })) : g('time_m', { m: m });
    var slot = el.querySelector('[data-mp-cutoff-time]');
    if (slot) slot.textContent = txt;
    else el.textContent = g('cutoff', { time: txt });
    el.hidden = false;
  }
  var cutoffTimer = null;
  function cutoffTick() {
    toArray(doc.querySelectorAll('[data-mp-cutoff]')).forEach(renderCutoff);
    // l'heure limite passee decale le jour de depart : les dates suivent sans recharger
    toArray(doc.querySelectorAll('[data-mp-eta]')).forEach(renderEta);
  }
  function eta(scope) {
    var root = scope || doc;
    toArray(root.querySelectorAll('[data-mp-eta]')).forEach(renderEta);
    var cut = toArray(root.querySelectorAll('[data-mp-cutoff]'));
    cut.forEach(renderCutoff);
    if (cfg.cutoffEnabled && cut.length && !cutoffTimer) {
      // rafraichi chaque minute (tick a 30 s pour ne jamais rater le changement de minute)
      cutoffTimer = setInterval(cutoffTick, 30000);
    }
  }

  /* ---------- Panier : MP.add (passe par MPCart.add si le tiroir est la) ---------- */
  function normalizeItems(items) {
    if (items == null) return [];
    if (typeof items === 'number' || typeof items === 'string') items = [{ id: items, quantity: 1 }];
    if (!Array.isArray(items)) items = [items];
    return items.map(function (it) {
      var o = { id: Number(it.id), quantity: Math.max(1, parseInt(it.quantity, 10) || 1) };
      if (it.properties) o.properties = it.properties;
      if (it.selling_plan) o.selling_plan = it.selling_plan;
      return o;
    }).filter(function (it) { return it.id > 0; });
  }
  function add(items) {
    var list = normalizeItems(items);
    if (!list.length) return Promise.reject({ message: g('select_size') });
    if (window.MPCart && typeof window.MPCart.add === 'function') {
      try { return Promise.resolve(window.MPCart.add(list)); } catch (e) { return Promise.reject(e); }
    }
    return fetch(cfg.routes.cartAdd, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: list })
    })
      .then(function (r) {
        return r.json().then(function (j) { if (!r.ok) throw j; return j; });
      })
      .then(function (j) {
        emit(doc, 'mp:cart:added', { items: list, response: j });
        window.location.href = cfg.routes.cart;
        return j;
      });
  }
  // messages Shopify (anglais ou francais selon la langue) -> formulations du theme (chaines mp.general.error_*)
  function errorText(err) {
    var generic = g('error_generic');
    if (!err) return generic;
    var msg = typeof err === 'string' ? err : (err.description || err.message || '');
    if (msg && typeof msg === 'object') msg = '';
    msg = String(msg || '');
    if (!msg) return generic;
    if (msg === g('select_size')) return msg;
    if (/sold out|out of stock|épuisé|n.est plus disponible|rupture/i.test(msg)) return g('error_sold_out');
    if (/all \d+|you can.t add more|can only add|maximum|tous les \d+|ne pouvez pas ajouter|quantité maximale/i.test(msg)) return g('error_max');
    if (/failed to fetch|network|load failed|réseau/i.test(msg)) return generic;
    return msg;
  }

  /* ---------- Section Rendering API : MP.section(id, url) -> Document ---------- */
  function section(id, url) {
    var u = new URL(localizeAny(url) || window.location.href, window.location.origin);
    u.searchParams.set('sections', id);
    return fetch(u.toString(), { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function (j) {
        if (!j || typeof j[id] !== 'string') throw new Error('Section not found: ' + id);
        return new DOMParser().parseFromString(j[id], 'text/html');
      });
  }

  /* ---------- Cartes produit : ajout rapide et pastilles ---------- */
  function closeQuick(except) {
    toArray(doc.querySelectorAll('[data-mp-quick].is-open')).forEach(function (w) {
      if (w === except) return;
      w.classList.remove('is-open');
      var t = w.querySelector('[data-mp-quick-toggle]');
      if (t) t.setAttribute('aria-expanded', 'false');
    });
  }
  function toggleQuick(btn, force) {
    var wrap = btn.closest('[data-mp-quick]');
    if (!wrap) return;
    var open = typeof force === 'boolean' ? force : !wrap.classList.contains('is-open');
    closeQuick(wrap);
    wrap.classList.toggle('is-open', open);
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) {
      var first = wrap.querySelector('[data-mp-quick-add]:not([disabled])');
      if (first) setTimeout(function () { first.focus(); }, 40);
    }
  }
  function setLabel(btn, text) {
    var l = btn.querySelector('[data-mp-label]');
    if (!l) return;
    if (!l.hasAttribute('data-mp-label-default')) l.setAttribute('data-mp-label-default', l.textContent);
    l.textContent = text == null ? l.getAttribute('data-mp-label-default') : text;
  }
  function quickAdd(btn) {
    if (btn.disabled || btn.getAttribute('aria-busy') === 'true') return;
    var id = btn.getAttribute('data-mp-quick-add');
    var wrap = btn.closest('[data-mp-quick]');
    var msg = wrap ? wrap.querySelector('[data-mp-quick-msg]') : null;
    if (msg) msg.textContent = '';
    btn.setAttribute('aria-busy', 'true');
    // bouton a libelle : "Adding…" puis "Added" ; pastille de taille : roue puis coche noire
    if (btn.querySelector('[data-mp-label]')) setLabel(btn, g('adding'));
    else btn.classList.add('is-loading');
    add([{ id: id, quantity: 1 }])
      .then(function () {
        btn.classList.remove('is-loading');
        btn.classList.add('is-added');
        setLabel(btn, g('added'));
        announce(g('added_announce'));
        setTimeout(function () {
          btn.classList.remove('is-added');
          setLabel(btn, null);
          if (wrap) {
            wrap.classList.remove('is-open');
            var t = wrap.querySelector('[data-mp-quick-toggle]');
            if (t) t.setAttribute('aria-expanded', 'false');
          }
        }, 1600);
      })
      .catch(function (err) {
        btn.classList.remove('is-loading');
        setLabel(btn, null);
        var text = errorText(err);
        if (msg) msg.textContent = text;
        announce(text);
      })
      .then(function () {
        btn.removeAttribute('aria-busy');
      });
  }
  // V1.12 : le nom de la couleur sous le titre et la pastille entouree suivent le survol
  function showColor(card, dot) {
    var label = card.querySelector('[data-mp-card-color]');
    var name = dot ? dot.getAttribute('data-mp-dot-color') : null;
    if (label) label.textContent = name || label.getAttribute('data-mp-color-now') || '';
    // V1.22 : « Almost sold out » suit la couleur survolee (data-mp-low sur la pastille), sinon l'etat d'origine
    var low = card.querySelector('[data-mp-card-low]');
    if (low) low.hidden = dot ? dot.getAttribute('data-mp-low') !== '1' : low.getAttribute('data-mp-low-now') !== 'true';
    card.querySelectorAll('.mp-card__dots .mp-dot').forEach(function (d) {
      if (!d.hasAttribute('data-mp-was-selected')) d.setAttribute('data-mp-was-selected', d.classList.contains('is-selected') ? '1' : '0');
      d.classList.toggle('is-selected', dot ? d === dot : d.getAttribute('data-mp-was-selected') === '1');
    });
  }
  function swapImage(dot) {
    var card = dot.closest('.mp-card');
    if (!card) return;
    showColor(card, dot);
    var img = card.querySelector('.mp-card__img--main');
    var src = dot.getAttribute('data-mp-swap');
    if (!img) return;
    // pastille de la couleur deja affichee : on revient a la photo d'origine
    if (!src) {
      if (img.hasAttribute('data-mp-src')) {
        var set0 = img.getAttribute('data-mp-srcset');
        if (set0) img.setAttribute('srcset', set0);
        img.setAttribute('src', img.getAttribute('data-mp-src'));
        card.classList.remove('is-swapped');
      }
      return;
    }
    if (!img.hasAttribute('data-mp-src')) {
      img.setAttribute('data-mp-src', img.getAttribute('src') || '');
      img.setAttribute('data-mp-srcset', img.getAttribute('srcset') || '');
    }
    var set = dot.getAttribute('data-mp-swap-srcset');
    if (set) img.setAttribute('srcset', set);
    else img.removeAttribute('srcset');
    img.setAttribute('src', src);
    card.classList.add('is-swapped');
  }
  function restoreImage(card) {
    showColor(card, null);
    var img = card.querySelector('.mp-card__img--main');
    if (!img || !img.hasAttribute('data-mp-src')) return;
    var set = img.getAttribute('data-mp-srcset');
    if (set) img.setAttribute('srcset', set);
    img.setAttribute('src', img.getAttribute('data-mp-src'));
    card.classList.remove('is-swapped');
  }
  function bindCards() {
    doc.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var tog = t.closest('[data-mp-quick-toggle]');
      if (tog) { e.preventDefault(); toggleQuick(tog); return; }
      var b = t.closest('[data-mp-quick-add]');
      if (b) { e.preventDefault(); e.stopPropagation(); quickAdd(b); return; }
      // V1.17 : sur mobile le focus ne suit pas toujours l'appui : un appui hors d'un ajout rapide ouvert le ferme
      if (!t.closest('[data-mp-quick].is-open')) closeQuick();
    });
    doc.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' && e.key !== 'Esc') return;
      var wrap = e.target && e.target.closest ? e.target.closest('[data-mp-quick].is-open') : null;
      if (!wrap) return;
      e.preventDefault();
      var tog = wrap.querySelector('[data-mp-quick-toggle]');
      if (tog) { toggleQuick(tog, false); tog.focus(); }
    });
    doc.addEventListener('focusout', function (e) {
      var wrap = e.target && e.target.closest ? e.target.closest('[data-mp-quick].is-open') : null;
      if (!wrap) return;
      if (e.relatedTarget && wrap.contains(e.relatedTarget)) return;
      setTimeout(function () { if (!wrap.contains(doc.activeElement)) closeQuick(); }, 0);
    });
    // pastilles : survol souris = photo de la couleur (ordinateur)
    doc.addEventListener('mouseover', function (e) {
      if (!MQ.hover.matches) return;
      var dot = e.target && e.target.closest ? e.target.closest('[data-mp-swap], .mp-card__dots .mp-dot') : null;
      if (dot) { swapImage(dot); dot.closest('.mp-card').classList.add('is-dotted'); }
    });
    doc.addEventListener('mouseout', function (e) {
      var card = e.target && e.target.closest ? e.target.closest('.mp-card.is-swapped, .mp-card.is-dotted') : null;
      if (!card) return;
      if (e.relatedTarget && card.contains(e.relatedTarget)) return;
      card.classList.remove('is-dotted');
      restoreImage(card);
    });
  }

  /* ---------- Liens et formulaires : prefixe de langue juste avant la navigation ---------- */
  // Ecouteurs en phase de capture : le href est corrige avant le clic (Ctrl/Cmd/clic milieu inclus : le navigateur lit
  // l'attribut au moment d'ouvrir) ; mousedown, touchstart et contextmenu couvrent clic milieu et "copier l'adresse".
  function fixLink(e) {
    if (!root) return;
    var t = e.target;
    if (!t || !t.closest) return;
    var a = t.closest('a[href]');
    if (!a || a.hasAttribute('download') || a.closest('[data-mp-no-locale]')) return;
    var raw = a.getAttribute('href');
    if (!raw || raw.charAt(0) === '#' || /^(?:mailto|tel|sms|javascript|data|blob):/i.test(raw)) return;
    var fixed = localizeAny(raw);
    if (fixed !== raw) a.setAttribute('href', fixed);
  }
  function fixForm(e) {
    if (!root) return;
    var f = e.target;
    if (!f || f.tagName !== 'FORM' || (f.closest && f.closest('[data-mp-no-locale]'))) return;
    var method = String(f.getAttribute('method') || 'get').toLowerCase();
    if (method !== 'get') return; // les formulaires POST (/cart, /localization...) sont geres par Shopify
    var act = f.getAttribute('action');
    if (!act || act.charAt(0) !== '/') return;
    var fixed = localizePath(act);
    if (fixed !== act) f.setAttribute('action', fixed);
  }
  function bindLocaleLinks() {
    if (!root) return;
    ['mousedown', 'click', 'auxclick', 'contextmenu'].forEach(function (ev) { doc.addEventListener(ev, fixLink, true); });
    try { doc.addEventListener('touchstart', fixLink, { capture: true, passive: true }); }
    catch (err) { doc.addEventListener('touchstart', fixLink, true); }
    doc.addEventListener('submit', fixForm, true);
  }

  /* ---------- Initialisation ---------- */
  function init(scope) {
    rows(scope);
    eta(scope);
  }

  var MP = window.MP || {};
  MP.__base = true;
  MP.version = '5.0';
  MP.config = cfg;
  MP.refreshConfig = function () { cfg = readConfig(); localizeRoutes(); MP.config = cfg; return cfg; };
  // prefixe de langue : MP.root ("" ou "/fr"), MP.url(chemin ou URL de meme origine) -> meme adresse avec le prefixe
  // si besoin. A utiliser pour tout fetch() vers une URL interne ecrite en dur (recommandations, rendu de section...).
  MP.root = root;
  MP.url = localizeAny;
  MP.money = money;
  // langue : MP.locale ("en", "fr"), MP.localeTag ("en-US", "fr-FR"), MP.i18n(surface) -> objet des chaines
  // data-mp-i18n="<surface>", MP.t(surface, cle, repliAnglais, vars) -> chaine, MP.fmt(chaine, vars) remplace
  // [nom] / {nom} / {{ nom }}, MP.date(Date) -> date courte dans la langue
  MP.locale = lang;
  MP.localeTag = localeTag;
  MP.i18n = i18n;
  MP.t = tr;
  MP.fmt = fmtStr;
  MP.date = fmt;
  MP.layer = layer;
  MP.rows = rows;
  MP.eta = eta;
  MP.etaDates = function (min, max) {
    return etaDates(min == null ? cfg.etaMin : min, max == null ? cfg.etaMax : max);
  };
  MP.isBusinessDay = function (date) {
    var d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), 12));
    return isBusinessDay(d);
  };
  MP.add = add;
  MP.errorText = errorText;
  MP.announce = announce;
  MP.section = section;
  MP.portal = portal;
  MP.ready = ready;
  MP.debounce = debounce;
  MP.mq = MQ;
  MP.emit = emit;
  MP.init = init;
  window.MP = MP;

  ready(function () {
    bindCards();
    bindLocaleLinks();
    init(doc);
    // editeur de theme : une section rechargee est reinitialisee (ses chaines i18n sont relues)
    doc.addEventListener('shopify:section:load', function (e) { i18nCache = {}; init(e.target); });
    // file d'attente pour les scripts en ligne executes avant mp-base.js : (window.MPQ = window.MPQ || []).push(fn)
    var queue = window.MPQ;
    window.MPQ = { push: function (fn) { try { fn(MP); } catch (err) { if (window.console) console.error(err); } } };
    if (Array.isArray(queue)) queue.forEach(function (fn) { window.MPQ.push(fn); });
    emit(doc, 'mp:ready', { MP: MP });
  });
})();
